<template>
    <div>
        <portal to="page-header">{{ $t('New Player') }}</portal>

        <portal to="actions">
            <back-button
                :route-name="'players.index'"
            >{{ $t('Players List') }}</back-button>
        </portal>

        <form @submit.prevent="submit">
            <div class="flex flex-wrap">
                <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                    <card>
                        <div class="flex flex-wrap">
                            <div class="px-4 py-2 w-full sm:w-32 md:w1/4">
                                <label for="username" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('Username') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-full sm:w-1/3">
                                <JetInput
                                    id="username"
                                    ref="username"
                                    type="text"
                                    :placeholder="$t('Username')"
                                    v-model="form.username"
                                    class="w-full form-control form-input"
                                    maxlength="20"
                                    autofocus
                                />
                                <JetInputError :message="errors.username" class="mt-2" />
                            </div>
                            <div class="py-2 px-4 pt-3 sm:w-1/3">
                                <button
                                    type="button"
                                    @click="generateUsername"
                                    class="px-4 py-2 mt-2 sm:mt-0 max-w-7xl text-sm text-center font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg cursor-pointer active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple no-wrap"
                                >{{ $t('Random Username') }}</button>
                            </div>
                        </div>
                    </card>
                </div>
            </div>

            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 mt-4 flex justify-between items-center">
                <div class="max-w-md mr-4"></div>
                <btn :processing="processing" :type="'submit'">
                    {{ $t('Create Player') }}
                </btn>
            </div>
        </form>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';

import PageHeader from '../../Components/PageHeader';
import Card from '../../Components/Card';
import BackButton from '../../Components/BackButton';
import Btn from '../../Components/Btn';

export default {
    name: "Create",
    components: {Btn, BackButton, JetInput, JetInputError, PageHeader, Card},
    props: {
        errors: Object
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('New Player');
        }
    },
    data() {
        return {
            form: {
                username: '',
            },
            processing: false
        }
    },
    methods: {
        async submit() {
            this.processing = true;
            await this.$inertia.post(route('players.store').url(), this.form);
            this.processing = false;
        },
        async generateUsername() {
            const result = await axios.get(route('players.username').url());

            this.form.username = result.data.username;
        }
    },
    mounted() {
        this.$refs.username.focus();
    }
}
</script>

<style scoped>

</style>
